import React from 'react'
import { UnderlinedButton } from 'jl-design-system/elements/button/Button'
import { SecondaryLink } from 'jl-design-system/elements/link/Link'
import requestNewLink from '../../../utils/auth0/requestNewLink'
import styles from './ResetPasswordLinkExpiredError.scss'

type Props = {
  code: string
}

export default function ResetPasswordLinkExpiredError({ code }: Props): JSX.Element {
  return (
    <div className={styles.container} data-testid="reset-password-link-expired-error">
      <section className={styles.section}>
        <p className={styles.title}>Reset links expire after 24 hours</p>
        <p className={styles.body}>
          Please{' '}
          <UnderlinedButton onClick={() => requestNewLink(code)} data-testid="request-new-link">
            request a new link
          </UnderlinedButton>
        </p>
      </section>

      <section className={styles.section}>
        <p className={styles.title}>Requested more than one link?</p>
        <p className={styles.body}>
          Links expire whenever you request a new one. Make sure you use the most recent one sent to
          you.
        </p>
      </section>

      <div className={styles.cta}>
        <SecondaryLink to="/#homepage" external data-testid="error-cta">
          Go to homepage
        </SecondaryLink>
      </div>
    </div>
  )
}
